import { render, staticRenderFns } from "./ReportRegister.vue?vue&type=template&id=4ea37c36"
import script from "./ReportRegister.vue?vue&type=script&lang=js"
export * from "./ReportRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports